
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_gwq0h_1ecwl_97",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_1ecwl_1",
  "trigger-expanded": "awsui_trigger-expanded_gwq0h_1ecwl_119",
  "icon": "awsui_icon_gwq0h_1ecwl_133",
  "root": "awsui_root_gwq0h_1ecwl_151",
  "expand-button": "awsui_expand-button_gwq0h_1ecwl_168",
  "expanded": "awsui_expanded_gwq0h_1ecwl_175",
  "icon-container": "awsui_icon-container_gwq0h_1ecwl_179",
  "icon-container-container": "awsui_icon-container-container_gwq0h_1ecwl_184",
  "wrapper": "awsui_wrapper_gwq0h_1ecwl_188",
  "wrapper-default": "awsui_wrapper-default_gwq0h_1ecwl_195",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_1ecwl_195",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_1ecwl_198",
  "wrapper-container": "awsui_wrapper-container_gwq0h_1ecwl_201",
  "header-deprecated": "awsui_header-deprecated_gwq0h_1ecwl_217",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_1ecwl_239",
  "header": "awsui_header_gwq0h_1ecwl_217",
  "header-wrapper": "awsui_header-wrapper_gwq0h_1ecwl_258",
  "header-button": "awsui_header-button_gwq0h_1ecwl_268",
  "header-container-button": "awsui_header-container-button_gwq0h_1ecwl_268",
  "header-container": "awsui_header-container_gwq0h_1ecwl_268",
  "header-navigation": "awsui_header-navigation_gwq0h_1ecwl_300",
  "header-text": "awsui_header-text_gwq0h_1ecwl_332",
  "content": "awsui_content_gwq0h_1ecwl_97",
  "content-default": "awsui_content-default_gwq0h_1ecwl_339",
  "content-footer": "awsui_content-footer_gwq0h_1ecwl_342",
  "content-expanded": "awsui_content-expanded_gwq0h_1ecwl_345",
  "focusable": "awsui_focusable_gwq0h_1ecwl_349",
  "click-target": "awsui_click-target_gwq0h_1ecwl_360"
};
  